import ULayout from "@/layout/pc/user";
const routes = [
  {
    path: "/user",
    name: "userhome",
    component: ULayout,
    children: [
      {
        path: "",
        redirect: { name: "userIndex" },
      },
      {
        path: "index",
        name: "userIndex",
        component: (resolve) => require(["pages/pc/user/index.vue"], resolve),
        meta: { showLeftMenu: true, requiresAuth: true },
      },
      {
        path: "address",
        name: "userAddress",
        component: (resolve) => require(["pages/pc/user/address"], resolve),
        meta: {
          showLeftMenu: true,
          requiresAuth: true,
        },
      },
      {
        path: "pwd",
        name: "userPwd",
        component: (resolve) => require(["pages/pc/user/pwd"], resolve),
        meta: {
          showLeftMenu: true,
          requiresAuth: true,
        },
      },

      {
        path: "notic",
        name: "userNotic",
        component: (resolve) => require(["pages/pc/user/notic"], resolve),
        meta: {
          showLeftMenu: true,
          requiresAuth: true,
        },
      },
      {
        path: "orders",
        name: "userOrders",
        component: (resolve) => require(["pages/pc/user/orders"], resolve),
        meta: {
          showLeftMenu: true,
          requiresAuth: true,
        },
      },
    ],
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/pc/user.js